import { Box, Collapse, Grid, Icon, Divider } from "@mui/material";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { getArrValues } from "utils/inspection";
import badgeDict from "modules/inspections/components/badgeDict.json";
import SprayCan from "assets/images/spray_can_white.png";
import BrokenDevice from "assets/images/broken_device_white.png";
import { getDeviceStatusColour, getDeviceBatteryStatus } from "utils/device";

export function actionItem(form_type, valueKey, title, values, devicePrimary, setFieldValue, setRemovedState, deviceLayout) {
    const isSelected = values?.[`devicePrimary-actions-${valueKey}`];

    return (
        <Grid item xxs={6}>
            <SoftBox display="flex" justifyContent="center" py={3} px={1}
                disabled={valueKey != 'removed' && values['devicePrimary-actions-removed']}
                onClick={(e) => {
                    if (valueKey !== 'removed' && values['devicePrimary-actions-removed']) return;
                    // console.log(e);
                    setFieldValue(devicePrimary.actions[valueKey].name, !values[`devicePrimary-actions-${valueKey}`]);
                    if (valueKey == 'removed') {
                        setRemovedState(!values[`devicePrimary-actions-${valueKey}`]);
                        var actions = ['installed', 'cleaned', 'battery_swap', 'hardware_changed', 'cosmetically_fixed'];
                        if (form_type == 'assignment') actions = actions.filter((row) => row != 'installed');

                        for (var action of actions) {
                            setFieldValue(devicePrimary.actions[action].name, false);
                        }
                    }
                }}
                sx={({ palette: { gradients }, functions: { rgba, linearGradient } }) => {
                    const isDisabled = valueKey !== 'removed' && values['devicePrimary-actions-removed'];
                    return {
                        borderRadius: '10px',
                        border: '1px solid #aaa',
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                        opacity: isDisabled ? 0.3 : 1,
                        background: linearGradient(rgba(gradients['light'].main, 0.6), isSelected ? rgba(gradients["success"].main, 0.2) : rgba(gradients['light'].state, 0.6))
                    }
                }}
            >
                <SoftBox display="flex" alignItems="center" sx={{ paddingTop: '2.5px' }}>
                    <SoftTypography variant={deviceLayout == "mobile" ? "mobileBody1" : "body2"} fontWeight={deviceLayout == "mobile" ? 'bold' : 'bold'}>{title}</SoftTypography>
                </SoftBox>
            </SoftBox>
        </Grid>
    )
};

export function deviceDisplay(values, isLastStep, deviceLabel, device = {}, showDeviceAttributes, setShowDeviceAttributes, showAdvancedDeviceLevel) {

    const hasSecondary = isLastStep && values?.['deviceSecondary-uuid']?.trim().length > 0;

    const conditions_actions = (
        <>
            <Grid item xxs={hasSecondary ? 12 : 6} sm={4}>
                <SoftBox display="flex" flexDirection="column" pb={1} px={{ xxs: 0, sm: 2 }}>
                    <SoftBox mb={1} ml={0.5}>
                        <SoftTypography variant="caption" fontWeight="bold">
                            Device Conditions
                        </SoftTypography>
                    </SoftBox>
                    {getArrValues(values, deviceLabel, "conditions").length > 0 ? getArrValues(values, deviceLabel, "conditions", true).map(([key, value], conIndex) => {
                        const borderSize = "20px"; //deviceLayout == "desktop" ? "20px" : "24px";
                        const fontSize = "18px"; //deviceLayout == "desktop" ? "18px" : "22px";

                        return (
                            <SoftBox key={conIndex}>
                                <SoftBox pl={0.5} pb={key == "other" ? 0 : 0.25} display="flex" flexDirection="row" alignItems="center">
                                    {badgeDict[key].icon == "SprayCan" ? (
                                        <SoftBox component="img" src={SprayCan} variant="gradient" bgColor={badgeDict[key].color} sx={{ borderRadius: "4px", width: borderSize, height: borderSize }} />
                                    ) : badgeDict[key].icon == "BrokenDevice" ? (
                                        <SoftBox component="img" src={BrokenDevice} variant="gradient" bgColor={badgeDict[key].color} sx={{ borderRadius: "4px", width: borderSize, height: borderSize }} />
                                    ) : (
                                        <SoftBox variant="gradient" bgColor={badgeDict[key].color} sx={{ borderRadius: "4px", width: borderSize, height: borderSize }}>
                                            <Icon fontSize={`${fontSize} !important`} sx={{ color: "#fff", fontSize: fontSize, display: "flex", alignItems: "center", justifyContent: "center", width: `${borderSize} !important`, height: `${borderSize} !important` }}>{badgeDict[key].icon}</Icon>
                                        </SoftBox>
                                    )}
                                    <SoftTypography pl={1} variant={"subtitle3" /*deviceLayout == "desktop" ? "subtitle3" : "subtitle2"*/} textTransform="capitalize">{key.replace("_", " ")}</SoftTypography>
                                </SoftBox>
                                {key == "other" && (
                                    <SoftBox pl={4}>
                                        <SoftTypography variant="caption">{value}</SoftTypography>
                                    </SoftBox>
                                )}
                            </SoftBox>
                        );
                    }) : (
                        <SoftBox pl={1}>
                            <SoftTypography variant="subtitle3" color="text">
                                None listed.
                            </SoftTypography>
                        </SoftBox>
                    )}
                </SoftBox>
            </Grid>
            <Box sx={{ width: 0, mx: { xxs: 0, sm: 2 }, display: { xxs: 'none', sm: 'flex' } }}>
                <Divider orientation="vertical" flexItem />
            </Box>
            <Grid item xxs={hasSecondary ? 12 : 6} sm={4}>
                <SoftBox display="flex" flexDirection="column" pb={1} px={{ xxs: 0, sm: 2 }}>
                    <SoftBox mb={1} ml={0.5}>
                        <SoftTypography variant="caption" fontWeight="bold">
                            Technician Actions
                        </SoftTypography>
                    </SoftBox>
                    {getArrValues(values, deviceLabel, "actions").length > 0 ? getArrValues(values, deviceLabel, "actions", true).map(([key, value], actIndex) => {
                        const borderSize = "20px"; //deviceLayout == "desktop" ? "20px" : "24px";
                        const fontSize = "18px"; //deviceLayout == "desktop" ? "18px" : "22px";

                        return (
                            <SoftBox key={actIndex}>
                                <SoftBox pl={0.5} pb={key == "other" ? 0 : 0.25} display="flex" flexDirection="row" alignItems="center">
                                    <SoftBox variant="gradient" bgColor={"success"} sx={{ borderRadius: "4px", width: borderSize, height: borderSize }}>
                                        <Icon fontSize={`${fontSize} !important`} sx={{ color: "#fff", fontSize, display: "flex", alignItems: "center", justifyContent: "center", width: `${borderSize} !important`, height: `${borderSize} !important` }}>check</Icon>
                                    </SoftBox>
                                    <SoftTypography pl={1} variant={"subtitle3" /*deviceLayout == "desktop" ? "subtitle3" : "subtitle2"*/} textTransform="capitalize">{key.replace("_", " ")}</SoftTypography>
                                </SoftBox>
                                {key == "other" && (
                                    <SoftBox pl={4}>
                                        <SoftTypography variant="caption">{value}</SoftTypography>
                                    </SoftBox>
                                )}
                            </SoftBox>
                        );
                    }) : (
                        <SoftBox pl={1}>
                            <SoftTypography variant="subtitle3" color="text">
                                None listed.
                            </SoftTypography>
                        </SoftBox>
                    )}
                </SoftBox>
            </Grid>
        </>
    );

    return (
        <SoftBox display="flex" flex={1} flexDirection={{ xxs: "column", sm: "row" }} my={{ xxs: 0, sm: 1 }} height="100%">
            <SoftBox display={{ xxs: 'none', sm: 'flex' }} flex={{ sm: 4 }}>
                <SoftBox display="flex" flexDirection="column" pb={1.5} px={{ xxs: 0, sm: 1 }}>
                    <SoftBox mb={1} ml={0.5}>
                        <SoftTypography variant="caption" fontWeight="bold">
                            {deviceLabel == 'devicePrimary' ? 'Inspected' : 'Replacement'} Device Details
                        </SoftTypography>
                    </SoftBox>
                    <SoftBox display="flex" flexDirection="column" pl={0.5}>
                        <SoftBox ml={1} display="flex" gap={0.5}>
                            <SoftTypography variant="subtitle3" color="text">
                                {values.organisation_id == "clearways" ? `eMinor:` : `Name:`}
                            </SoftTypography>
                            <SoftTypography variant="subtitle3" color="dark">
                                {values[`${deviceLabel}-info`].label}
                            </SoftTypography>
                        </SoftBox>
                        <SoftBox ml={1} display="flex" gap={0.5}>
                            <SoftTypography variant="subtitle3" color="text">
                                {values.organisation_id == "clearways" ? `Site ID:` : `Stop ID:`}
                            </SoftTypography>
                            <SoftTypography variant="subtitle3" color="dark">
                                {values[`${deviceLabel}-stop_id`]}
                            </SoftTypography>
                        </SoftBox>
                        <SoftBox ml={1} mb={1} display="flex" gap={0.5}>
                            <SoftTypography variant="subtitle3" color="text">Serial No:</SoftTypography>
                            <SoftTypography variant="subtitle3" color="dark">{values[`${deviceLabel}-serial_no`]}</SoftTypography>
                        </SoftBox>
                    </SoftBox>
                </SoftBox>
            </SoftBox>
            <Box display={{ xxs: 'none', sm: 'flex' }} sx={{ width: 0, mx: { xxs: 0, sm: 2 } }}>
                <Divider orientation="vertical" flexItem />
            </Box>
            <SoftBox width="100%" display={{ xxs: "flex", sm: 'none' }} flex={{ xxs: 12 }} flexDirection="column">
                <SoftBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    onClick={() => setShowDeviceAttributes(!showDeviceAttributes)}
                    p={1}
                    gap={1.25}
                    sx={{
                        backgroundColor: '#f0f0f0',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s',
                        '&:hover': { backgroundColor: '#e9ecef' }
                    }}
                >
                    <SoftBox display="flex" alignItems="center">
                        <SoftTypography variant="subtitle3" fontWeight="bold" color="text" sx={{ fontSize: "0.675rem" }}>
                            {showDeviceAttributes ? ('Hide ' + (deviceLabel == 'devicePrimary' ? 'Inspected' : 'Replacement')) : ('Show ' + (deviceLabel == 'devicePrimary' ? 'Inspected' : 'Replacement'))} Device Details
                            <Icon sx={{ display: hasSecondary ? 'inline-block' : 'none' }} color="secondary">{showDeviceAttributes ? 'expand_less' : 'expand_more'}</Icon>
                        </SoftTypography>
                        <Icon sx={{ display: hasSecondary ? 'none' : 'inline-block' }} color="secondary">{showDeviceAttributes ? 'expand_less' : 'expand_more'}</Icon>
                    </SoftBox>
                    <SoftBox display="flex" flexDirection={hasSecondary ? "column" : "row"} justifyContent="center" alignItems="center" gap={hasSecondary ? 0 : 1}>
                        <Icon sx={{ color: getDeviceStatusColour(device.battery, device.connected_state, showAdvancedDeviceLevel), fontSize: "20px !important" }}>power_settings_new</Icon>
                        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" pb={0.5}>
                            <Icon sx={{ color: getDeviceBatteryStatus(device.battery), transform: 'rotate(90deg)', width: '12px !important' }}>battery_charging_full</Icon>
                            <SoftTypography variant="menuCaption" fontWeight="medium">{device.battery}%</SoftTypography>
                        </SoftBox>
                    </SoftBox>
                </SoftBox>
                <Collapse in={showDeviceAttributes}>
                    <SoftBox display="flex" flex={{ sm: 4 }}>
                        <SoftBox display="flex" flexDirection="column" pb={0.5} px={{ xxs: 0, sm: 1 }}>
                            <SoftBox display="flex" flexDirection="column">
                                <SoftBox ml={1} mt={1} display="flex" gap={0.5}>
                                    <SoftTypography variant="subtitle3" color="text">
                                        {values.organisation_id == "clearways" ? `eMinor:` : `Name:`}
                                        <SoftTypography pl={0.5} variant="subtitle3" color="dark">
                                            {values[`${deviceLabel}-info`].label}
                                        </SoftTypography>
                                    </SoftTypography>
                                </SoftBox>
                                <SoftBox ml={1} display="flex" gap={0.5}>
                                    <SoftTypography variant="subtitle3" color="text">
                                        {values.organisation_id == "clearways" ? `Site ID:` : `Stop ID:`}
                                    </SoftTypography>
                                    <SoftTypography variant="subtitle3" color="dark">
                                        {values[`${deviceLabel}-stop_id`]}
                                    </SoftTypography>
                                </SoftBox>
                                <SoftBox ml={1} display="flex" gap={0.5}>
                                    <SoftTypography variant="subtitle3" color="text">Serial No:</SoftTypography>
                                    <SoftTypography variant="subtitle3" color="dark">{values[`${deviceLabel}-serial_no`]}</SoftTypography>
                                </SoftBox>
                            </SoftBox>
                        </SoftBox>
                    </SoftBox>
                    <Box display={{ xxs: 'none', sm: 'flex' }} sx={{ width: 0, mx: { xxs: 0, sm: 2 } }}>
                        <Divider orientation="vertical" flexItem />
                    </Box>
                    <Grid container mt={1}>
                        {conditions_actions}
                    </Grid>
                </Collapse>
            </SoftBox>
            <Grid container display={{ xxs: 'none', sm: 'contents' }}>
                {conditions_actions}
            </Grid>
        </SoftBox>
    );
}